const state = {
  permissions: []
};

export default {
  namespaced: true,
  state,
  mutations: {
    setPermissions(state, permissions) {
      state.permissions = permissions;
    }
  },
  actions: {
    fetchPermissions({ commit }, payload) {
      commit('SET_LOADING', true, { root: true });
      const { user_id } = payload;
      return axios
        .get(`api/v1/user/${user_id}/permission`)
        .then(response => {
          commit('setPermissions', response.data);
        })
        .finally(() => {
          commit('SET_LOADING', false, { root: true });
        });
    }
  }
};
